import { render, staticRenderFns } from "./update-notice.vue?vue&type=template&id=3f705085&scoped=true&lang=html&"
import script from "./update-notice.vue?vue&type=script&lang=js&"
export * from "./update-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f705085",
  null
  
)

export default component.exports